<template>
  <div class="dev-main ">

    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
        <el-card class="box-card clearfix category" style="max-height: 586px;overflow: auto">

          <el-menu :default-active="activeCategoryId" mode="horizontal" class="el-menu-demo">
            <el-menu-item v-for="(o,index) in categoryList" :index="o.categoryId" :key="o.categoryId"
                          @click="getTopics(o.categoryId)">{{o.categoryName}}
            </el-menu-item>
          </el-menu>

        </el-card>
        <el-card class="box-card clearfix" style="text-align: left;position: relative">
          <router-link class="clearfix" v-for="item1 in topicList" :key="item1.id"
                       :to="{path: item1.categoryId == '2' ? '/question/detail':'/contribute/detail',query: { topicId: item1.id,categoryId:item1.categoryId}}">
            <div>
              <span class="topic-title ellipsis" style="width: calc(100% - 110px)"> {{item1.title}}</span>
              <span class="topic-date">{{item1.updateDate | formatDate}}</span>
            </div>
            <div class="clearfix">
              <el-tag class="tag" v-for="subItem in  item1.subCategoryList" :key="subItem.id" type="info">
                {{subItem.subCategoryName}}
              </el-tag>
            </div>


            <el-divider></el-divider>
          </router-link>
          <PageComponent ref="pageInfo"></PageComponent>

        </el-card>

      </el-col>
      <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-card class="box-card ">
          <div class="clearfix">
            <div class="fl">
              <router-link :to="{path:'/question/add'}" style="margin-right: 20px">
                <el-button class="sign main-bg-color" size="mini">
                  <span class="submit-word">提问</span>
                </el-button>
              </router-link>
              <router-link :to="{path:'/contribute/add'}">
                <el-button class="sign main-bg-color" size="mini">
                  <span class="submit-word">投稿</span></el-button>
              </router-link>
            </div>
            <div class="fr">
              <div v-if="user && user.loginId && user.loginId != null" class="vertical">
                <img :src="$baseUrl+'img/avatar.png'" style="width:16px"/>
                <span style="font-size: 12px">{{user.loginId}}</span>
              </div>
              <router-link v-else :to="{path:'/login'}" class="vertical view-more">
                <i class="el-icon-user-solid"></i>
                <span style="font-size: 12px">去登录</span>
              </router-link>
            </div>
          </div>
        </el-card>
        <el-card class="box-card clearfix">
          <div class="qus">
            <span class="title bold">提问推荐</span>
          </div>

          <div class="bottom clearfix" v-for="item in recommendQuestionList" :key="item.id">

            <el-divider></el-divider>
            <div @click="gotoNextRouter(item)" class="qus pointer">
              <span class="title ellipsis">{{item.title}}</span>
              <el-tag class="tag" v-for="subItem in  item.subCategoryList" :key="subItem.id" type="info">
                {{subItem.subCategoryName}}
              </el-tag>
              <div class="fr" style="margin-top: 15px;color: #999999;font-size: 12px">
                <span>回答{{item.respCnt}}</span>
              </div>
            </div>

          </div>

        </el-card>
        <el-card class="box-card clearfix">
          <div class="qus">
            <span class="title bold">专栏推荐</span>
          </div>

          <div class="bottom clearfix" v-for="item in recommendContributeList" :key="item.id">

            <el-divider></el-divider>
            <div @click="gotoNextRouter(item)" class="qus">
              <span class="title ellipsis">{{item.title}}</span>
              <el-tag class="tag" v-for="subItem in  item.subCategoryList" :key="subItem.id" type="info">
                {{subItem.subCategoryName}}
              </el-tag>
              <div class="fr" style="margin-top: 15px;color: #999999;font-size: 12px">
                <span>{{item.updateDate | formatDate}}</span>
              </div>
            </div>

          </div>

        </el-card>

        <el-image :src="$baseUrl+'/img/activity.jpg'" style="margin-top: 10px">
          <div slot="placeholder" class="image-slot">
            加载中<span class="dot">...</span>
          </div>
        </el-image>

        <el-card class="box-card clearfix">

          <div style="text-align: left;margin-bottom: 20px;margin-left: 3px">
            关注我们
          </div>
          <div class="vertical">
            <img :src="$baseUrl+'img/pxy-ewm.png'" style="width: 79px"/>
            <span style="text-align: left;font-size: 14px;margin-right:0;margin-left:10px;
            vertical-align: top;width: calc(100% - 100px);line-height: 25px">
              邮箱：support@pingxingyun.com
              <br/>QQ群：716122787
            </span>
          </div>
        </el-card>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";

  export default {
    components: {PageComponent},
    data() {
      return {
        activeCategoryId: this.$route.query.categoryId,
        categoryList: [],
        subCategoryList: [],
        topicList: [],
        topicResponses: [],
        userInfo: {},
        showRespAreaFlag: false,
        recommendQuestionList: [],
        recommendContributeList:[]
      }
    },
    computed: {
      realHeight() {
        return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 200
      },
      user() {
        return this.$store.state.user;
      },
      routes() {
        return this.$store.state.routes
      }
    },
    created() {

    },
    methods: {
      getTopicResponsesLength: function (topicId) {
        return this.getRequest('/tccTopic/getDetailList', {
          topicId: topicId,
          page: 1,
          pageSize: 20
        }).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              return resp.data.result.records.length;
            }
          } else {
            return 0;
          }
        })
      },
      getSubCategory: function (subCategoryId) {
        return this.getRequest('/tccTopic/getSubCategoryList', {'subCategoryId': subCategoryId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              return resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getRecommendQuestions: function (subCategoryId) {
        var params = {};
        if(subCategoryId != null){
          params.subCategoryId = subCategoryId;
        }
        params.categoryId = 2;
        params.page = 1;
        params.pageSize = 3;
        this.getRequest('/tccTopic/getList', params).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.recommendQuestionList = resp.data.result.records;
              for (var i = 0; i < this.recommendQuestionList.length; i++) {
                await this.getTopicResponsesLength(this.recommendQuestionList[i].id).then(resp => {
                  var cnt = resp;
                  this.$set(this.recommendQuestionList[i], 'respCnt', cnt);
                });
                await this.getSubCategory(this.recommendQuestionList[i].subCategoryId).then(resp => {
                  this.$set(this.recommendQuestionList[i], 'subCategoryList', resp)
                });
              }
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },

      getRecommendContributes: function (subCategoryId) {
        var params = {};
        if(subCategoryId != null){
          params.subCategoryId = subCategoryId;
        }
        params.categoryId = 3;
        params.page = 1;
        params.pageSize = 3;
        this.getRequest('/tccTopic/getList', params).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.recommendContributeList = resp.data.result.records;
              for (var i = 0; i < this.recommendContributeList.length; i++) {
                await this.getSubCategory(this.recommendContributeList[i].subCategoryId).then(resp => {
                  this.$set(this.recommendContributeList[i], 'subCategoryList', resp)
                });
              }
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getCategories: function () {
        this.getRequest('/tccTopic/getCategoryList', {}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.categoryList = resp.data.result;
              this.getTopics(this.activeCategoryId)
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })

      },

      getTopics: function (categoryId) {
        if(categoryId){
          this.activeCategoryId = categoryId;
        }
        var params = {};
        params.categoryId = this.activeCategoryId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        this.getRequest('/tccTopic/getList', params).then(async resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.topicList = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
              for (var i = 0; i < this.topicList.length; i++) {
                await this.getSubCategory(this.topicList[i].subCategoryId).then(resp => {
                  this.$set(this.topicList[i], 'subCategoryList', resp)
                });
              }
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      gotoNextRouter: function (o) {
        this.$router.push({path: '/question/detail', query: {topicId: o.id, categoryId: this.activeCategoryId}});
        this.form.topicId = o.id;
      },
    }
    ,
    mounted: function () {
      this.getCategories();
      this.getRecommendQuestions();
      this.getRecommendContributes();
      this.$emit('setActiveIndex', "6")
      this.$refs.pageInfo.initPagenator(this.getTopics, null);
    }
    ,
    beforeDestroy() {
    }
  }
</script>

